'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _rpUtils = require('rp-utils');

var _rpMqBreakpoints = require('rp-mq-breakpoints');

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

var _rpDiffusionConnector = require('rp-diffusion-connector');

var _rpDiffusionConnector2 = _interopRequireDefault(_rpDiffusionConnector);

var _DiffusionServiceUtils = require('./utils/DiffusionServiceUtils');

var _PricesStateStore = require('./stores/PricesStateStore');

var _DIFFUSION = require('./constants/DIFFUSION');

var _DIFFUSION2 = _interopRequireDefault(_DIFFUSION);

var _EVENTS = require('./constants/EVENTS');

var _EVENTS2 = _interopRequireDefault(_EVENTS);

var _PopOver2 = require('./utils/PopOver');

var _PopOver3 = _interopRequireDefault(_PopOver2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */

// eslint-disable-next-line import/no-extraneous-dependencies, import/no-unresolved


var narrowBreakpoints = [_rpMqBreakpoints.breakpointCodes.EXTRA_NARROW, _rpMqBreakpoints.breakpointCodes.NARROW];

var BestOddsPopOver = function (_PopOver) {
    _inherits(BestOddsPopOver, _PopOver);

    function BestOddsPopOver() {
        _classCallCheck(this, BestOddsPopOver);

        return _possibleConstructorReturn(this, (BestOddsPopOver.__proto__ || Object.getPrototypeOf(BestOddsPopOver)).apply(this, arguments));
    }

    _createClass(BestOddsPopOver, [{
        key: 'open',
        value: function open(e) {
            var currentBookmaker = _PricesStateStore.pricesStateStore.getCurrentBookmaker();
            if (currentBookmaker !== '#BESTODDS') {
                return;
            }
            _get(BestOddsPopOver.prototype.__proto__ || Object.getPrototypeOf(BestOddsPopOver.prototype), 'open', this).call(this, e);
            (0, _jquery2.default)(window).on(_EVENTS2.default.RESIZE, this.config.onResizeHandler);
            (0, _jquery2.default)(window).on(_EVENTS2.default.SWITCH_BREAKPOINTS, this.config.onBreakpointChange);
        }
    }, {
        key: 'close',
        value: function close(e) {
            (0, _jquery2.default)(window).off(_EVENTS2.default.RESIZE, this.config.onResizeHandler);
            (0, _jquery2.default)(window).off(_EVENTS2.default.SWITCH_BREAKPOINTS, this.config.onBreakpointChange);
            _get(BestOddsPopOver.prototype.__proto__ || Object.getPrototypeOf(BestOddsPopOver.prototype), 'close', this).call(this, e);
        }
    }]);

    return BestOddsPopOver;
}(_PopOver3.default);

var defaultConfig = {
    bestOddsContainerSelector: '.js-bestOddsPriceContainer',
    diffusionConfigs: '.js-diffusionHorsesList',
    priceBtnOddsSelector: '.js-PC-bestOdds__priceBtn',
    activeBestOddsSelector: {
        popOver: '.js-PC-bestOdds',
        horseList: '.js-diffusionBestOdds',
        arrow: '.js-PC-bestOdds__arrow'
    },
    bestOddsArrowHiddenClass: 'PC-bestOdds__arrow_hidden',
    bestOddsArrowRight: 'PC-bestOdds__arrow_right',
    bestOddsArrowLeft: 'PC-bestOdds__arrow_left',
    noPointerClass: 'RC-runnerPrice_noPointer',
    bestOddsArrowHeight: 27,
    sideMarginInPx: 16,
    bestOddsArrowPositionInPx: {
        min: 7,
        max: 488
    },
    popOverConfig: {
        activeClass: 'PC-bestOdds_active',
        popOverSelector: '.js-PC-bestOdds',
        openAreaSelector: '.js-runnerPriceBestOdds',
        shadowAreaSelectors: '.PC-bestOddsOverlay',
        diffusionConfig: '.js-diffusionBestOdds',
        runnerName: '.js-bestOddsHorseName'
    }
};

var BestOdds = function () {
    function BestOdds(config) {
        _classCallCheck(this, BestOdds);

        this.config = _jquery2.default.extend(true, defaultConfig, config);

        if ((0, _rpDiffusionConnector.shouldEstablishSession)()) {
            this.init();
            // here we will store the bookmakers offers (tier1 and tier2) fetched from janus
            this.bookmakersOffers = [];
        }
    }

    _createClass(BestOdds, [{
        key: 'init',
        value: function init() {
            this.diffusionSession = new _rpDiffusionConnector2.default({
                onDataFunction: this.onDataReceive.bind(this)
            });

            this.showDecimalPrices = false;
            this.initOverlay();
            this.bindEvents();
            this.$bestOdds = (0, _jquery2.default)(this.config.popOverConfig.popOverSelector);
            this.$bestOddsParent = this.$bestOdds.parent();
            this.initPopover();
            this.fetchBookmakers();
        }
    }, {
        key: 'setBookmakersOpenAccountLinks',
        value: function setBookmakersOpenAccountLinks() {
            /**
             * With this function we set the open account links for the bookmakers
             * just need to have same html structure for the bestOdds like in the horse-tracker
             * bestOdds.volt file
             *
             * Then with this function we get the open account links rendered in the volt file
             * and manipulate them
             */
            if (this.bookmakersOffers.length === 0) {
                return;
            }

            var isMobile = window.innerWidth <= 720;

            var tier1Offers = isMobile ? this.bookmakersOffers.bookmakerOffersMobile : this.bookmakersOffers.bookmakerOffersDesktop;
            var tier2Offers = isMobile ? this.bookmakersOffers.bookmakerOffersTierTwoMobile : this.bookmakersOffers.bookmakerOffersTierTwoDesktop;

            var setOpenAccountLinks = function setOpenAccountLinks(elements, offers) {
                elements.each(function (index, el) {
                    var $el = $(el);
                    var bookieName = $el.data('bookie-name').toLowerCase();
                    if (!bookieName) return;

                    var offer = offers.find(function (o) {
                        return o.name.toLowerCase() === bookieName;
                    });
                    if (offer) {
                        // [JP-10331] for tote we use signUpLink8 rather than signUpLink3
                        if (bookieName === 'tote') {
                            if (offer.signUpLink8) {
                                $el.attr('href', offer.signUpLink8);
                            } else {
                                $el.hide();
                            }
                        } else if (offer.signUpLink3) {
                            $el.attr('href', offer.signUpLink3);
                        } else {
                            $el.hide();
                        }
                    }
                });
            };

            /**
             * for now we need manipulation for the open account links
             * for tier 2 only with the ticket JP-10331
             * but in the future we can use the same logic for tier 1
             *
             * const tier1OpenAccountLinks = $('.js-tier1-open-account-link');
             * setOpenAccountLinks(tier1OpenAccountLinks, [...tier1Offers, ...tier2Offers]);
             */

            var tier2OpenAccountLinks = $('.js-tier2-open-account-link');
            setOpenAccountLinks(tier2OpenAccountLinks, [].concat(_toConsumableArray(tier1Offers), _toConsumableArray(tier2Offers)));
        }
    }, {
        key: 'fetchBookmakers',
        value: function fetchBookmakers() {
            var _this2 = this;

            (0, _rpUtils.fetchBookmakersMixed)().then(function (bookmakersOffers) {
                _this2.bookmakersOffers = bookmakersOffers;
            });
        }
    }, {
        key: 'toggleOpenAccountLinksForTierTwo',
        value: function toggleOpenAccountLinksForTierTwo() {
            /**
             * on mobile we hide the open account links for tier 2
             */
            if (window.innerWidth <= 720) {
                (0, _jquery2.default)('.js-tier2-open-account-link').hide();
            } else {
                (0, _jquery2.default)('.js-tier2-open-account-link').show();
            }
        }
    }, {
        key: 'initOverlay',
        value: function initOverlay() {
            this.overlay = (0, _jquery2.default)('<div class="PC-bestOddsOverlay"></div>');
            (0, _jquery2.default)('body').append(this.overlay);
        }
    }, {
        key: 'initPopover',
        value: function initPopover() {
            var popoverOptions = this.getPopoverOptions();
            this.popOver = new BestOddsPopOver(popoverOptions);
        }
    }, {
        key: 'getPopoverOptions',
        value: function getPopoverOptions() {
            return {
                activeClass: this.config.popOverConfig.activeClass,
                popOverSelector: this.config.popOverConfig.popOverSelector,
                openAreaSelectors: [this.config.popOverConfig.openAreaSelector],
                closeAreaSelectors: [this.config.priceBtnOddsSelector, this.config.popOverConfig.shadowAreaSelectors],
                onOpen: this.onPopOverOpen.bind(this),
                onClose: this.onPopOverClose.bind(this),
                onResizeHandler: this.onResizeHandler.bind(this),
                onBreakpointChange: this.onBreakpointChange.bind(this)
            };
        }
    }, {
        key: 'onPopOverOpen',
        value: function onPopOverOpen(e) {
            this.overlay.show();
            this.prepareDiffusionData(e);
            this.pricesSubscribe();
            this.setOriginPrice(e.target);
            this.handleBestOddsPosition();
            this.toggleOpenAccountLinksForTierTwo();
            this.setBookmakersOpenAccountLinks();

            // eslint-disable-next-line array-callback-return
            (0, _jquery2.default)('.PC-bestOdds__bookieRow__name_account.ui-link').each(function (_, element) {
                var currentHref = element.getAttribute('href');

                if (!currentHref.includes('/redirect/')) {
                    var bookmakerRedirectUrl = '/redirect/?url=' + encodeURIComponent(currentHref) + '&name=' + element.getAttribute('bookmaker-name');
                    element.setAttribute('href', bookmakerRedirectUrl);
                }
            });
        }
    }, {
        key: 'onPopOverClose',
        value: function onPopOverClose() {
            // todo: add check - JP-10398
            // if (this.diffusionSession) {
            //     this.diffusionSession.unsubscribeAll();
            // }

            this.diffusionSession.unsubscribeAll();
            this.toggleOpenAccountLinksForTierTwo();
            this.clearPopUp();
            this.overlay.hide();
            this.$bestOdds.detach();
            this.$bestOddsParent.append(this.$bestOdds);
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            (0, _jquery2.default)(document).on(_EVENTS2.default.USER_SETTINGS_CHANGED, this.onUserSettingsChanged.bind(this));
            (0, _jquery2.default)(document).on(_EVENTS2.default.DYNAMIC_PRICES_UPDATED, this.onDynamicsRunnersUpdate.bind(this));
            (0, _jquery2.default)(document).on(_EVENTS2.default.HORSES_LIST_CHANGED, this.onDynamicsRunnersUpdate.bind(this));
        }
    }, {
        key: 'onUserSettingsChanged',
        value: function onUserSettingsChanged(event, userSettings) {
            this.showDecimalPrices = userSettings.decimalOdds;
        }
    }, {
        key: 'onDynamicsRunnersUpdate',
        value: function onDynamicsRunnersUpdate() {
            this.popOver.destroy();
            this.initPopover();
        }
    }, {
        key: 'onDataReceive',
        value: function onDataReceive(webClientMessage) {
            var topic = webClientMessage.getTopic();

            if (topic.includes('#INFO')) {
                this.handleRaceInfo(webClientMessage);
            } else {
                this.handleHorsePrice(webClientMessage);
            }
        }
    }, {
        key: 'prepareDiffusionData',
        value: function prepareDiffusionData(event) {
            var $diffusionHorseListElem = (0, _jquery2.default)(event.target).closest(this.config.diffusionConfigs);
            var diffusionHorseName = $diffusionHorseListElem.attr(_DIFFUSION2.default.DATA.INPUT.HORSE_NAME);
            var raceDate = _DiffusionServiceUtils.diffusionServiceUtils.getTopicRaceDate($diffusionHorseListElem);
            var raceTime = _DiffusionServiceUtils.diffusionServiceUtils.getTopicRaceTime($diffusionHorseListElem);
            var courseName = _DiffusionServiceUtils.diffusionServiceUtils.getTopicCourseName($diffusionHorseListElem);

            (0, _jquery2.default)(this.config.popOverConfig.runnerName).text(diffusionHorseName);
            var $diffusionBestOdds = (0, _jquery2.default)(this.config.popOverConfig.diffusionConfig);
            this.$bestOdds.detach();

            $diffusionBestOdds.attr(_DIFFUSION2.default.DATA.INPUT.HORSE_NAME, diffusionHorseName).attr(_DIFFUSION2.default.DATA.INPUT.COURSE_NAME, courseName).attr(_DIFFUSION2.default.DATA.INPUT.RACE_TIME, raceTime).attr(_DIFFUSION2.default.DATA.INPUT.RACE_DATE, raceDate);

            var $priceContainer = (0, _jquery2.default)(event.target).closest(this.config.bestOddsContainerSelector);
            $priceContainer.append(this.$bestOdds);
        }
    }, {
        key: 'handleRaceInfo',
        value: function handleRaceInfo(WebClientMessage) {
            var raceInfo = _DiffusionServiceUtils.diffusionServiceUtils.parseInfoTopicData(WebClientMessage);

            this.renderEwInfo(raceInfo);
            _PricesStateStore.pricesStateStore.updateRaceInfo(raceInfo);
            if (raceInfo.suspendState === 'H') {
                this.updatePricesForRaceInfo(raceInfo.bookmaker);
            }
        }
    }, {
        key: 'handleHorsePrice',
        value: function handleHorsePrice(WebClientMessage) {
            var renderConfig = _DiffusionServiceUtils.diffusionServiceUtils.parsePriceTopicData(WebClientMessage);

            this.renderPrice(renderConfig);
        }
    }, {
        key: 'renderPrice',
        value: function renderPrice(renderConfig) {
            /** TODO: filter was used due to PhantomJS/Jasmine-jquery doesn't (JIRA: PC-4557)
             * support CSS selector search with data attributes
             */

            // const bookieContainerSelector = `[data-diffusion-bookmaker="${renderConfig}"]`;
            var popOver = (0, _jquery2.default)(this.config.activeBestOddsSelector.popOver);
            var pricesContainer = popOver.find(this.config.popOverConfig.diffusionConfig);
            var bookieContainer = Array.prototype.filter.call(pricesContainer, function (el) {
                return el.dataset.diffusionBookmaker === renderConfig.bookmaker;
            });
            var priceButton = (0, _jquery2.default)(bookieContainer).find(this.config.priceBtnOddsSelector)[0];

            this.clearBestOddsPosition();

            if (priceButton) {
                var renderPriceValue = _DiffusionServiceUtils.diffusionServiceUtils.getDisplayedPriceValue(renderConfig);
                priceButton.innerHTML = renderPriceValue;
                if (renderPriceValue === '-') {
                    priceButton.classList.add(this.config.noPointerClass);
                } else {
                    priceButton.classList.remove(this.config.noPointerClass);
                }
                var raceInfo = _PricesStateStore.pricesStateStore.getRaceInfo(renderConfig);
                var dataDiffusionStatus = raceInfo && raceInfo.suspendState === 'H' ? 'H' : renderConfig.status;

                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.OUTCOMERS_ID, renderConfig.outcomersId);
                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL, renderConfig.fractionalPrice);
                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL, renderConfig.decimalPrice);
                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.STATUS, dataDiffusionStatus);
                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.EVENT_ID, renderConfig.eventId);
                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.MEETING_ID, renderConfig.meetingId);

                bookieContainer[0].classList.add('PC-bestOdds__bookieRow_active');
                this.sortPrices(bookieContainer);
            }
            this.handleBestOddsPosition();
        }
    }, {
        key: 'sortPrices',
        value: function sortPrices(bookieRow) {
            var isMobile = window.innerWidth < 720;

            var bookieContainer = (0, _jquery2.default)(bookieRow).closest('.PC-bestOdds__bookiesList').find('.PC-bestOdds__bookieRow_active');

            if (bookieContainer.length === 0) {
                return;
            }

            var priceBtnOddsSelector = this.config.priceBtnOddsSelector;

            bookieContainer.toArray().map(function (item) {
                return {
                    bookie: item.getAttribute('data-diffusion-bookieName').toLowerCase(),
                    price: (0, _jquery2.default)(item).find(priceBtnOddsSelector).attr(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL),
                    element: item
                };
            }).sort(function (prev, next) {
                if (isMobile) {
                    if (prev.bookie === 'betfred') return 1;
                    if (next.bookie === 'betfred') return -1;
                }

                if (isNaN(prev.price) && isNaN(next.price) || prev.price === next.price) {
                    if (prev.bookie > next.bookie) return 1;
                    if (prev.bookie < next.bookie) return -1;
                    return 0;
                } else if (isNaN(prev.price)) {
                    return 1;
                } else if (isNaN(next.price)) {
                    return 0;
                }
                return next.price - prev.price;
            }).forEach(function (elem, index) {
                var bookieElement = elem.element;
                bookieElement.style.order = index;
            });
        }
    }, {
        key: 'pricesSubscribe',
        value: function pricesSubscribe() {
            var horsesList = (0, _jquery2.default)(this.config.activeBestOddsSelector.horseList).toArray();
            var topics = horsesList.map(function (horseElement) {
                var bookmaker = _DiffusionServiceUtils.diffusionServiceUtils.getTopicBookmaker(horseElement);
                var diffusionData = _DiffusionServiceUtils.diffusionServiceUtils.getElementDiffusionData(horseElement);

                return _extends(diffusionData, { bookmaker: bookmaker });
            }).map(function (diffusionData) {
                var priceTopic = _DiffusionServiceUtils.diffusionServiceUtils.createPriceTopic(diffusionData);
                var infoTopic = _DiffusionServiceUtils.diffusionServiceUtils.createInfoTopic(diffusionData);

                return [priceTopic, infoTopic];
            }).reduce(function (acum, value) {
                return acum.concat(value);
            }, []).filter(function (topic) {
                return topic;
            });

            if (this.diffusionSession) {
                this.diffusionSession.subscribe({ topics: topics });
            }
        }
    }, {
        key: 'renderEwInfo',
        value: function renderEwInfo(renderConfig) {
            /** TODO: filter was used due to PhantomJS/Jasmine-jquery doesn't (JIRA: PC-4557)
             * support CSS selector search with data attributes
             */

            // const bookieContainerSelector = `[data-diffusion-bookmaker="${renderConfig.bookmaker}"]`;

            var popOver = (0, _jquery2.default)(this.config.activeBestOddsSelector.popOver);
            var pricesContainer = popOver.find(this.config.popOverConfig.diffusionConfig);
            var bookieContainer = (0, _jquery2.default)(Array.prototype.filter.call(pricesContainer, function (el) {
                return el.dataset.diffusionBookmaker === renderConfig.bookmaker;
            }));
            var ewElement = bookieContainer.find('.js-diffusionBestOdds_eachWay')[0];
            var bogElement = bookieContainer.find('.js-diffusionBestOdds_bog')[0];

            if (ewElement) {
                ewElement.innerHTML = renderConfig.isWinOnly ? '<b>win only</b>' : [renderConfig.winOdds, renderConfig.placeWinner].join(' ');
            }

            if (bogElement) {
                if (renderConfig.isBog === 'Y') {
                    bogElement.classList.add('PC-bestOdds__bookieRow__oddsIcon_active');
                } else {
                    bogElement.classList.remove('PC-bestOdds__bookieRow__oddsIcon_active');
                }
            }
        }
    }, {
        key: 'clearPopUp',
        value: function clearPopUp() {
            var _this3 = this;

            var diffusionRows = (0, _jquery2.default)(this.config.activeBestOddsSelector.horseList);

            Array.prototype.forEach.call(diffusionRows, function (element) {
                var priceBtn = (0, _jquery2.default)(element).find(_this3.config.priceBtnOddsSelector)[0];

                element.classList.remove('PC-bestOdds__bookieRow_active');

                _this3.renderEwInfo({
                    winOdds: '',
                    placeWinner: '',
                    isBog: 'N',
                    bookmaker: element.getAttribute(_DIFFUSION2.default.DATA.INPUT.BOOKMAKER)
                });
                priceBtn.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL, '');
                priceBtn.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL, '');
                priceBtn.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.OUTCOMERS_ID, '');
                priceBtn.innerHTML = '';
            });
        }
    }, {
        key: 'handleBestOddsPosition',
        value: function handleBestOddsPosition() {
            var popOver = (0, _jquery2.default)(this.config.activeBestOddsSelector.popOver)[0];
            var popOverArrow = (0, _jquery2.default)(this.config.activeBestOddsSelector.arrow)[0];
            var windowHeight = window.innerHeight;
            var windowWidth = window.innerWidth;
            var bestOddsRect = popOver.getBoundingClientRect();
            var bestOddsArrowPositionMax = bestOddsRect.height - this.config.bestOddsArrowHeight;
            var $priceContainer = (0, _jquery2.default)(this.originPrice).closest(this.config.bestOddsContainerSelector);
            var priceContainerRect = $priceContainer.length ? $priceContainer[0].getBoundingClientRect() : null;
            var originPriceRect = this.originPrice.getBoundingClientRect();
            var targetContainerRect = priceContainerRect && priceContainerRect.width && priceContainerRect.height > originPriceRect.height ? priceContainerRect : originPriceRect;
            var isWideBreakpoint = narrowBreakpoints.indexOf(_rpMqBreakpoints2.default.current().code) === -1;

            var calculatedTop = -(bestOddsRect.height - targetContainerRect.height) / 2;
            var spaceToTop = targetContainerRect.top + calculatedTop;
            var spaceToBottom = windowHeight - (targetContainerRect.top + calculatedTop + bestOddsRect.height);
            var calculatedLeft = void 0;

            // Vertical Alignment

            if (spaceToTop < this.config.sideMarginInPx && spaceToBottom > this.config.sideMarginInPx) {
                calculatedTop = this.config.sideMarginInPx - targetContainerRect.top;
            } else if (spaceToBottom < this.config.sideMarginInPx && spaceToTop > this.config.sideMarginInPx) {
                calculatedTop = windowHeight - targetContainerRect.top - bestOddsRect.height - this.config.sideMarginInPx;
            }
            var arrowTop = -(calculatedTop - (targetContainerRect.height - this.config.bestOddsArrowHeight) / 2);

            // Arrow alignment
            if (arrowTop < this.config.bestOddsArrowPositionInPx.min || arrowTop > bestOddsArrowPositionMax) {
                popOverArrow.classList.add(this.config.bestOddsArrowHiddenClass);
            } else {
                popOverArrow.setAttribute('style', 'top:' + arrowTop + 'px');
            }
            // Horizontal alignment

            if (isWideBreakpoint) {
                calculatedLeft = targetContainerRect.width + 16;
            } else {
                calculatedLeft = (windowWidth - bestOddsRect.width) / 2 - targetContainerRect.left;
            }

            if (windowWidth < targetContainerRect.left + calculatedLeft + bestOddsRect.width + this.config.sideMarginInPx && isWideBreakpoint) {
                calculatedLeft = -(bestOddsRect.width + 16);
                popOverArrow.classList.add(this.config.bestOddsArrowRight);
            } else {
                popOverArrow.classList.add(this.config.bestOddsArrowLeft);
            }

            if (calculatedLeft) {
                popOver.setAttribute('style', 'top:' + calculatedTop + 'px; left:' + calculatedLeft + 'px');
            } else {
                popOver.setAttribute('style', 'top:' + calculatedTop + 'px');
            }
        }
    }, {
        key: 'clearBestOddsPosition',
        value: function clearBestOddsPosition() {
            var arrow = (0, _jquery2.default)(this.config.activeBestOddsSelector.arrow)[0];
            arrow.setAttribute('style', '');
            arrow.classList.remove(this.config.bestOddsArrowHiddenClass);
            arrow.classList.remove(this.config.bestOddsArrowRight);
            arrow.classList.remove(this.config.bestOddsArrowLeft);

            (0, _jquery2.default)(this.config.activeBestOddsSelector.popOver)[0].setAttribute('style', '');
        }
    }, {
        key: 'onResizeHandler',
        value: function onResizeHandler() {
            this.clearBestOddsPosition();
            this.handleBestOddsPosition();
        }
    }, {
        key: 'onBreakpointChange',
        value: function onBreakpointChange() {
            this.popOver.close();
            this.toggleOpenAccountLinksForTierTwo();
        }
    }, {
        key: 'updatePricesForRaceInfo',
        value: function updatePricesForRaceInfo(bookmaker) {
            var _this4 = this;

            var bookieElements = (0, _jquery2.default)(this.config.activeBestOddsSelector.popOver).find(this.config.popOverConfig.diffusionConfig).toArray();

            bookieElements.filter(function (el) {
                return el.getAttribute(_DIFFUSION2.default.DATA.INPUT.BOOKMAKER) === bookmaker;
            }).map(function (el) {
                return (0, _jquery2.default)(el).find(_this4.config.priceBtnOddsSelector)[0];
            }).forEach(function (el) {
                var priceInfo = _this4.getRenderConfigFromElement(el);
                var getRaceInfo = _DiffusionServiceUtils.diffusionServiceUtils.getElementDiffusionData(el);
                var renderConfig = _extends(priceInfo, getRaceInfo, { bookmaker: bookmaker });
                // TODO: clear is some esear way (JIRA: PC-4557)
                _this4.renderPrice(renderConfig);
            });
        }
        // TODO: move to private function or to utils (JIRA: PC-4559)
        /* eslint-disable class-methods-use-this */

    }, {
        key: 'getRenderConfigFromElement',
        value: function getRenderConfigFromElement(element) {
            return {
                outcomersId: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.OUTCOMERS_ID),
                fractionalPrice: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL),
                decimalPrice: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL),
                historyPrice: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.HISTORY),
                eventId: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.EVENT_ID),
                meetingId: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.MEETING_ID)
            };
        }
        /* eslint-enable class-methods-use-this */

    }, {
        key: 'setOriginPrice',
        value: function setOriginPrice(newPrice) {
            this.originPriceElement = newPrice;
        }
    }, {
        key: 'originPrice',
        get: function get() {
            return this.originPriceElement;
        }
    }]);

    return BestOdds;
}();

exports.default = BestOdds;


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/lib/js/BestOdds.js
// module id = 2689
// module chunks = 0